// utils/number.ts
export const formatNumberWithCommas = (
  value: number | string | null | undefined
): string | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  // System expects empty string for zero
  if (numericValue === 0) {
    return "";
  }

  // Remove decimals without rounding
  const integerValue = Math.round(numericValue);

  return integerValue.toLocaleString();
};
export const formatNumberDecimalEnterWithCommas = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const stringValue = value.toString().replace(/,/g, "");

  if (isNaN(Number(stringValue))) {
    return "";
  }

  // Split integer & decimal parts
  const [integerPart, decimalPart] = stringValue.split(".");
  const formattedInteger = Number(integerPart).toLocaleString();

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
};

export const formatNumberDecimalWithCommas = (
  value: number | string | null | undefined
): string | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  // System expects empty string for zero
  if (numericValue === 0) {
    return "";
  }
  const integerValue = numericValue;

  return integerValue.toLocaleString();
};

export const formatNumberPlain = (
  value: number | string | null | undefined
): string | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  // System expects empty string for zero
  if (numericValue === 0) {
    return "";
  }

  // Remove decimals without rounding
  const integerValue = Math.trunc(numericValue);

  return String(integerValue);
};

export const formatNumericTwoDecimalInputWithCommas = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const numericValue = Number(String(value).replace(/,/g, ""));

  if (!Number.isFinite(numericValue)) {
    return "";
  }

  return numericValue.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};
